import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import _ from "lodash";
import Table from "@material-ui/core/Table";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import StatisticsRow from "./stats-row";

const QUERY = gql`
  query($limit: Int!, $skip: Int!, $filter: StatsFilter) {
    stats(limit: $limit, skip: $skip, filter: $filter) {
      total
      data {
        id
        value
        resource {
          name
        }
        probabilityValue
        typing
        year
        description
        indicator {
          name
        }
      }
      rows
    }
  }
`;

const actionsStyles = theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5
  }
});

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = event => {
    this.props.onChangePage(event, 0);
  };

  handleBackButtonClick = event => {
    this.props.onChangePage(event, this.props.page - 1);
  };

  handleNextButtonClick = event => {
    this.props.onChangePage(event, this.props.page + 1);
  };

  handleLastPageButtonClick = event => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
    );
  };

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props;

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }
}

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {
  withTheme: true
})(TablePaginationActions);

class StatsTable extends Component {
  state = {
    page: 0,
    rowsPerPage: 50
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: _.parseInt(event.target.value) });
  };

  render() {
    const { page, rowsPerPage } = this.state;
    const { filter } = this.props;
    const variables = { limit: rowsPerPage, skip: page * rowsPerPage, filter };
    return (
      <Query query={QUERY} variables={variables}>
        {({ data, loading, error }) => {
          if (error) return "Ocurrio un error ...";
          else if (loading) return "Cargando ...";
          else {
            /*  console.log({ data });
            const {
              stats: { data, rows, total }
            } = data;*/
            const { stats } = data;
            const statsRows = stats.data.map(row => (
              <StatisticsRow
                key={row.id}
                row={row}
                query={QUERY}
                variables={variables}
              />
            ));
            return (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Recurso</TableCell>
                    <TableCell align="right">Indicador</TableCell>
                    <TableCell align="right">Año</TableCell>
                    <TableCell align="right">Grupo</TableCell>
                    <TableCell align="right">Valor</TableCell>
                    <TableCell align="right">PrP</TableCell>
                    <TableCell align="right">Descripción</TableCell>
                    <TableCell align="right">Operaciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{statsRows}</TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      labelRowsPerPage="Filas por página"
                      rowsPerPageOptions={[50, 100, 200]}
                      colSpan={3}
                      count={stats.total}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        native: true
                      }}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActionsWrapped}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            );
          }
        }}
      </Query>
    );
  }
}

export default StatsTable;



// WEBPACK FOOTER //
// ./src/components/stats/table.js